export default {"src":"/_next/static/media/headphones.a4197116.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};